import { UiHelperService } from '../../ui-helper/services/ui-helper.service';
import { IToken, IBaseTokenGroup } from '../interfaces/token.interface';
import { Injectable, Inject } from '@angular/core';
import { JWT_KEY_NAME } from '../constants/consts';

@Injectable()
export class JwtService {
    lastTokenUpdateTime: Date;

    constructor(private uiHelper: UiHelperService, @Inject(JWT_KEY_NAME) private jwtKeyName: string) { }

    set token(token: string) {
        if (this.uiHelper.isBrowser) {
            sessionStorage.setItem(this.jwtKeyName, token);
            this.lastTokenUpdateTime = new Date();
        }
    }

    get token(): string {
        if (this.uiHelper.isBrowser) {
            return sessionStorage.getItem(this.jwtKeyName);
        }
        return null;
    }

    setToken(token: string, tokenGroup?: IBaseTokenGroup): IToken {
        if (this.uiHelper.isBrowser) {
            sessionStorage.setItem(tokenGroup as string || this.jwtKeyName, token);
            this.lastTokenUpdateTime = new Date();
            return { key: tokenGroup as string || this.jwtKeyName, value: token };
        }
        return null;
    }

    getToken(tokenGroup?: IBaseTokenGroup): IToken {
        if (this.uiHelper.isBrowser) {
            const token = sessionStorage.getItem(tokenGroup as string || this.jwtKeyName);
            return { key: tokenGroup as string || this.jwtKeyName, value: token };
        }
        return null;
    }

    cleanToken() {
        if (this.uiHelper.isBrowser) {
            sessionStorage.removeItem(this.jwtKeyName);
            this.lastTokenUpdateTime = null;
        }
    }
}
